export class NaiveEngine {
  constructor() { this.state = Object.freeze({ label: 'NAIVE_COLLAPSED_PIPELINE', persisted: [], observations: [] }); }
  consume(events, { recallCount = 0 } = {}) {
    const representationCounts = new Map();
    const persisted = [];
    const observations = events.map((event) => {
      const count = (representationCounts.get(event.representation) || 0) + 1;
      representationCounts.set(event.representation, count);
      const shouldPersist = event.salience >= 0.8 || count >= 3 || event.confidence >= 0.9 || recallCount >= 2;
      if (shouldPersist && !persisted.includes(event.representation)) persisted.push(event.representation);
      return Object.freeze({ eventId: event.eventId, repetitionCount: count, shouldPersist });
    });
    this.state = Object.freeze({ label: 'NAIVE_COLLAPSED_PIPELINE', persisted: Object.freeze(persisted), observations: Object.freeze(observations) });
    return this.state;
  }
}
